import React, { ReactNode, useEffect, useState } from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { Select, message } from 'antd';
import { EventName, ModeOptions } from '@/utils/constant';
import CockpitManageApi from '@/fetch/bussiness/cockpitManage';
import {
  CockpitMode,
  CockpitModeText,
  CockpitStatus,
  IssueDrawerData,
} from '@/utils/type';
import {
  getClstag,
  getPermissionById,
  isEmpty,
  transIssueDurationTime,
} from '@/utils/util';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useNavigate } from 'react-router-dom';
import { sendGlobalEvent } from '@/utils/emit';
import { actionExitCockpit } from '@/redux/reducers/newCommon';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { showModal } from '@/components/Modal';
export enum AcceptIssueStatus {
  ACCEPT = 'ACCEPT',
  STOP = 'STOP',
}
const fetchApi = new CockpitManageApi();
const SettingBoard = (props: { handleClose: () => void }) => {
  const navigate = useNavigate();
  const dispath = useDispatch();
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const login = useSelector((state: RootState) => state.login);
  const issue = useSelector((state: RootState) => state.issue);
  const { userInfo, teamInfo, cockpitTeamName, cockpitStatus, cockpitMode } =
    newCommon || {};
  const [modeBtn, setModeBtn] = useState<any>(null);
  const { workTimeTotal, workStartTime, completeIssueCount } = userInfo || {};
  const todayWorkTime = workStartTime ? Date.now() - workStartTime : 0;
  const todayWorkTimeTotal = workTimeTotal
    ? todayWorkTime + workTimeTotal * 1000
    : todayWorkTime;
  const [selectMode, setSelectMode] = useState<CockpitMode>(
    newCommon.cockpitMode || CockpitMode.LISTENING_MODE
  );
  const options: any[] = [];
  _.cloneDeep(ModeOptions)
    ?.slice(0, 4)
    ?.forEach((item) => {
      if (getPermissionById(item.permissionId)) {
        options.push({
          label: item.label,
          value: item.value,
        });
      }
    });
  const quitCockpit = () => {
    (window as any).globalNotShowOfflineTip = true;
    fetchApi.quitCockpit().then((res) => {
      if (res.code === HttpStatusCode.Success) {
        message.success('退出座席成功');
        props.handleClose();
        dispath(actionExitCockpit());
        setTimeout(() => {
          (window as any).globalNotShowOfflineTip = false;
          navigate('/app/home');
          sendGlobalEvent('RESET_STATUS');
        }, 500);
      } else {
        message.error(res.message);
      }
    });
  };

  const enterCockpit = () => {
    request({
      path: '/monitor/web/cockpit/enterCockpit',
      method: Method.POST,
      body: {
        cockpitMode: selectMode,
        cockpitNumber: newCommon.cockpitNumber,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        sendGlobalEvent(EventName.CREATE_MQTT_CLIENT);
        setTimeout(() => {
          navigate('/app/multivehicle');
        }, 500);
      } else {
        message.error(res.message);
      }
    });
  };

  const showErrorModal = (msg: string) => {
    showModal({
      title: '数据异常',
      content: msg,
      closable: false,
      keyboard: false,
      footer: {
        showOk: true,
        okText: '跳转到坐席模式选择页面',
        okFunc: () => {
          location.href = '/app/home';
        },
      },
    });
  };

  const handleModeBtnClick = async () => {
    try {
      const res = await fetchApi.switchStatus({
        acceptIssueStatus: modeBtn.acceptIssueStatus,
        nextStatus: modeBtn.nextStatus,
        cockpitNumber: newCommon.cockpitNumber,
      });

      if (res?.code !== HttpStatusCode.Success) {
        showErrorModal(res.message);
      }
    } catch (e) {
      showErrorModal(typeof e === 'string' ? e : '网络请求错误');
    }
  };

  useEffect(() => {
    const goRest = isEmpty(issue.list);
    const restAfterIssue = !isEmpty(issue.list);
    const goWork = newCommon.cockpitStatus === CockpitStatus.REST;
    const cancle =
      !isEmpty(issue.list) &&
      userInfo?.acceptIssueStatus === AcceptIssueStatus.STOP;
    if (goWork) {
      setModeBtn({
        classname: 'goWork',
        text: '工作',
        acceptIssueStatus: AcceptIssueStatus.ACCEPT,
        nextStatus: CockpitStatus.WORK,
        clstag: getClstag(newCommon.cockpitMode, 'MultiPage_Work'),
      });
    } else if (cancle) {
      setModeBtn({
        classname: 'cancle',
        text: '取消',
        acceptIssueStatus: AcceptIssueStatus.ACCEPT,
        nextStatus: CockpitStatus.WORK,
      });
    } else if (goRest) {
      setModeBtn({
        classname: 'goRest',
        text: '休息',
        acceptIssueStatus: AcceptIssueStatus.STOP,
        nextStatus: CockpitStatus.REST,
        clstag: getClstag(newCommon.cockpitMode, 'MultiPage_Rest'),
      });
    } else if (restAfterIssue) {
      setModeBtn({
        classname: 'restAfterIssue',
        text: '结单后休息',
        acceptIssueStatus: AcceptIssueStatus.STOP,
        nextStatus: CockpitStatus.WORK,
        clstag: getClstag(newCommon.cockpitMode, 'MultiPage_RestAfterComplete'),
      });
    }
  }, [
    newCommon.cockpitStatus,
    userInfo?.acceptIssueStatus,
    JSON.stringify(issue.list?.map((i: IssueDrawerData) => i.issueNumber)),
  ]);

  return (
    <div className="cockpit-setting-board">
      <div className="mode-setting-content">
        <div className="mode-select">
          <i className="label">模式选择</i>
          <Select
            options={options}
            value={selectMode}
            onChange={(value: CockpitMode) => {
              request({
                path: '/monitor/web/cockpit/switchMode',
                method: Method.POST,
                body: {
                  cockpitMode: value,
                  cockpitNumber: newCommon.cockpitNumber,
                },
              }).then((res) => {
                if (res.code === HttpStatusCode.Success) {
                  message.success(CockpitModeText[value] + '切换成功');
                  setSelectMode(value);
                  sendGlobalEvent('RESET_STATUS');
                  if (value === CockpitMode.PATROL_MODE) {
                    navigate('/app/multivehicle');
                  }
                } else {
                  message.error(res.message);
                }
              });
            }}
          />
        </div>
        {[
          CockpitMode.LISTENING_MODE,
          CockpitMode.WATCH_CAR_MODE,
          CockpitMode.PATROL_MODE,
          CockpitMode.FREE_MODE,
          CockpitMode.MAP_COLLECTION_MODE,
        ].includes(cockpitMode) ? (
          <div className="exit-btn" onClick={quitCockpit}>
            退出座席
          </div>
        ) : (
          <div className="enter-btn" onClick={enterCockpit}>
            入座座席
          </div>
        )}
      </div>
      {cockpitMode && (
        <div className="work-info-board">
          <div className="user-work-detail">
            <div className="left-box">
              <i className="user-avatar"></i>
              <div className="detail-content">
                <i className="tag">个人</i>
                <i>{login?.userInfo?.userName}</i>
              </div>
            </div>
            <div className="center">
              <i className="issue-num">{completeIssueCount}</i>
              <i>今日工单处理量</i>
            </div>
            <div className="right">
              <span className="work-time">
                <i>
                  {todayWorkTimeTotal
                    ? transIssueDurationTime(todayWorkTimeTotal)
                    : '--'}
                </i>
                <i>今日工作时长</i>
              </span>
              {modeBtn && (
                <div
                  className={`mode-btn ${modeBtn.classname}`}
                  onClick={handleModeBtnClick}
                  clstag={modeBtn.clstag}
                >
                  <i className="ico"></i>
                  <i>{modeBtn.text}</i>
                </div>
              )}
            </div>
          </div>
          <div className="team-work-detail">
            <div className="left-box">
              <i className="vehicle-icon"></i>
              <div className="detail-content">
                <i className="tag">团队</i>
                <i>{cockpitTeamName}</i>
              </div>
            </div>
            <div className="center">
              <i className="issue-num">{teamInfo?.completeIssueCount || 0}</i>
              <i>今日工单处理量</i>
            </div>
            <div className="right">
              <i>{teamInfo?.waitAcceptIssueCount || 0}</i>
              <i>待处理工单数</i>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingBoard;
